import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import CheckboxIcon from './CheckboxIcon';

import './CheckboxList.less';

export default function CustomLabel({ isActive, apiKeyName, label, count }) {
  const isColor = apiKeyName === 'COLOR';
  const classNameContainer = classNames('checkbox-list__section-label', {
    'is-active': isActive,
    'color-label': isColor,
  });
  const classNameColor = classNames('swatch__inner', label);

  return (
    <div className="checkbox-list-section__label-wrapper">
      <CheckboxIcon apiKeyName={apiKeyName} />
      <div className={classNameContainer}>
        {isColor ? (
          <span className="checkbox-list-section__swatch swatch">
            {label && <span className={classNameColor} />}
          </span>
        ) : (
          ''
        )}
        {label}
        <span className="checkbox-list__section-counter">{`(${count})`}</span>
      </div>
    </div>
  );
}

CustomLabel.propTypes = {
  isActive: propTypes.bool,
  apiKeyName: propTypes.string,
  label: propTypes.string,
  count: propTypes.number,
};
